var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 26,
    viewBox: "0 0 50 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_483)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.595606 4.10629H3.76603C3.91039 4.10629 4.02829 4.22634 4.02829 4.37274V19.2003C4.02829 20.6043 4.41978 20.9096 5.44938 20.9096H6.45509C6.59945 20.9096 6.71734 21.0295 6.71734 21.1761V23.8599C6.71734 24.0061 6.5991 24.1264 6.45509 24.1264H4.51241C2.09145 24.1264 0.333008 22.636 0.333008 19.8828V4.37274C0.333008 4.22617 0.451074 4.10629 0.595262 4.10629H0.595606Z",
    fill: "#274068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1456 9.70968C24.8829 9.70968 21.8632 12.8784 21.8632 17.1293C21.8632 21.3802 24.8574 24.4966 29.2218 24.4975C32.1243 24.498 34.923 23.1012 35.9524 19.9873C36.0189 19.7861 35.9013 19.6767 35.736 19.6767H32.612C32.3537 19.6767 32.3033 19.7385 32.1071 19.9862C30.6691 21.8013 26.1213 21.7774 25.5865 18.1337H36.0344C36.2043 18.1337 36.2834 18.0435 36.2918 17.8768C36.5255 13.3345 33.6796 9.70985 29.1454 9.70985L29.1456 9.70968ZM32.4004 15.3516H25.764C26.5561 12.3071 31.5948 12.2389 32.4004 15.3516Z",
    fill: "#274068"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64038 6.10629C7.66049 4.64284 8.43093 3.84979 9.90014 3.83967C11.3693 3.84979 12.1398 4.64267 12.1599 6.10629C12.1398 7.56973 11.3693 8.36279 9.90014 8.37291C8.43093 8.36279 7.66049 7.56991 7.64038 6.10629Z",
    fill: "#274068"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31495 10.0811H11.4854C11.6297 10.0811 11.7478 10.2012 11.7478 10.3476V23.8595C11.7478 24.0059 11.6297 24.126 11.4854 24.126H8.31495C8.17076 24.126 8.05252 24.0061 8.05252 23.8595V10.3476C8.05252 10.2012 8.17059 10.0811 8.31495 10.0811Z",
    fill: "#274068"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.231 24.126H18.4014C18.5457 24.126 18.6636 24.0061 18.6636 23.8596V13.2977H21.6741C21.8181 13.2977 21.9363 13.1777 21.9363 13.0314V10.3476C21.9363 10.2014 21.8183 10.0812 21.6741 10.0812H18.6636V9.03196C18.6636 7.62819 18.9214 7.32266 19.951 7.32266H21.6741C21.8184 7.32266 21.9363 7.20261 21.9363 7.05639V4.37256C21.9363 4.22634 21.8179 4.10629 21.6741 4.10629H19.1479C16.727 4.10629 14.9685 5.59661 14.9685 8.34971V10.0812H13.6468C13.5026 10.0812 13.3845 10.201 13.3845 10.3476V13.0314C13.3845 13.178 13.5028 13.2977 13.6468 13.2977H14.9685V23.8596C14.9685 24.0061 15.0866 24.126 15.2308 24.126H15.231Z",
    fill: "#274068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6351 2.28882e-05C39.9649 0.000720847 33.4709 9.15305 37.8916 13.1372C41.965 16.8083 50.7799 12.4073 50.1138 10.5139C49.7653 9.52349 48.1711 9.72101 46.6105 9.91836C45.2435 10.0913 43.902 10.2642 43.4461 9.639C42.4873 8.32475 46.8038 1.15759 44.3531 0.136823C44.1306 0.0439943 43.8901 2.28882e-05 43.6356 2.28882e-05L43.6351 2.28882e-05Z",
    fill: "url(#paint0_linear_86_483)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_483",
    x1: 46.1369,
    y1: 6.00002,
    x2: 36.1021,
    y2: 12.4373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2255F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605769,
    stopColor: "#00A2FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7aa3a7a2.svg";
export { ForwardRef as ReactComponent };